/* eslint-disable max-len */
var UI_CHECKMARK_CIRLCE = {
  "default": 'M32,16A16,16,0,1,1,27.13,4.52L25.83,6A14,14,0,1,0,30,16a14.08,14.08,0,0,0-.81-4.66l1.48-1.73A16,16,0,0,1,32,16ZM9.93,13.47A1,1,0,0,0,8.62,15h0l7.73,6.73a1,1,0,0,0,.73.25,1,1,0,0,0,.69-.35L31,6.1a1,1,0,1,0-1.52-1.3L16.9,19.54Z',
  globetrotter: 'M22.5 11.19L14.29 20.82L9.5 16.64M29.5 16C29.5 23.46 23.46 29.5 16 29.5C8.54 29.5 2.5 23.46 2.5 16C2.5 8.54 8.54 2.5 16 2.5C23.46 2.5 29.5 8.54 29.5 16Z'
};

export { UI_CHECKMARK_CIRLCE };
//# sourceMappingURL=UI_CHECKMARK_CIRCLE.js.map
